import React from "react";
import { twMerge } from "tailwind-merge";
export type IButton = {
  type?: "button" | "submit";
  title: string;
  onClick: () => void;
  className?: string;
  children?: React.ReactNode;
  loading?: boolean;
};

const Button: React.FC<IButton> = ({
  type = "button",
  title,
  className,
  onClick,
  children,
  loading,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={twMerge(
        "border-none px-3 py-2 font-bold flex items-center text-white justify-center rounded-md bg-primary-500  hover:bg-primary-700 transition ease-in-out duration-300",
        className
      )}
    >
      {loading && (
        <div>
          <svg
            className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
      )}
      {children} {title}
    </button>
  );
};

export default Button;
